var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useState } from 'react';
import { apiGetListClientSeminar, apiCreateClientSeminarView, } from '../../../actions/ClientSeminarActions';
import { useColumnListFilterSearch } from '../../../container/Column/Common/UseCase/ColumnListSearchUseCase';
import { wrapDispatch } from '../../action';
import { useBoolState } from '../useHook';
import { useClientSeminarSaveViewEvent } from './useClientSeminarSaveViewEvent';
/**
 * セミナー検索処理
 * @param options
 * @returns {*}
 */
export const useClientSeminarListSearch = (options) => {
    const { dispatch, locationStateKey, unmountRef } = options;
    // 資料モーダルに表示させる画像一覧
    const [seminarIdDisplayedDocument, setSeminarIdDisplayedDocument] = useState(null);
    const [images, changeImages] = useState([]);
    const { boolState: isShowDocumentModal, changeFalse: hideDocumentModal, changeTrue: showDocumentModal, } = useBoolState();
    /**
     * セミナー検索
     * @type {function(*, *=): Promise<unknown>}
     */
    const searchColumns = useCallback((params, page) => __awaiter(void 0, void 0, void 0, function* () {
        // 種別の値を整形
        const { types } = params;
        const typeParams = {};
        (types || '')
            .split(',')
            .filter((v) => v)
            .forEach((key) => {
            typeParams[key] = 1;
        });
        const action = apiGetListClientSeminar(Object.assign({ categories: params.theme, page: page || 1, preview_id: params.previewId }, typeParams));
        // 一覧データ 取得
        const response = yield wrapDispatch(dispatch, action);
        return {
            currentPage: response.currentPage,
            lastPage: response.lastPage,
            list: response.payload.list,
        };
    }), [dispatch]);
    const { getReplaceUrl, loadApi: loadSeminars, loading, onChangeTypeFilter, onClickTheme: onClickCategory, onLoadMoreApi: onLoadMoreSeminars, paging, } = useColumnListFilterSearch(locationStateKey, searchColumns, unmountRef);
    // セミナー資料の閲覧ログ保存
    const { onChangeDocumentImage } = useClientSeminarSaveViewEvent({
        dispatch,
        isShowDocumentModal,
        seminarId: seminarIdDisplayedDocument,
    });
    const { articles: seminars } = paging;
    /**
     * 資料表示ボタンをクリックした際のイベント
     * @type {(function())|*}
     */
    const onClickDocument = useCallback((e) => {
        var _a;
        const { value } = e.currentTarget;
        const id = parseInt(value, 10);
        // 検索結果から該当するセミナーを取得する
        const { information } = seminars.find((v) => v.id === id) || {};
        // 分割画像が存在する場合、モーダル表示用に画像をセット
        const seminarImages = ((_a = information === null || information === void 0 ? void 0 : information.images) === null || _a === void 0 ? void 0 : _a.map((v) => v.path)) || [];
        changeImages(seminarImages);
        // モーダル表示
        setSeminarIdDisplayedDocument(id);
        showDocumentModal();
    }, [changeImages, seminars, showDocumentModal]);
    const onClickSearchResult = useCallback((e) => {
        const { dataset } = e.currentTarget;
        const { result_id: resultId, text } = dataset;
        dispatch(apiCreateClientSeminarView(resultId, { text }));
    }, [dispatch]);
    return {
        getReplaceUrl,
        hideDocumentModal,
        images,
        isShowDocumentModal,
        loadSeminars,
        loading,
        onChangeDocumentImage,
        onChangeTypeFilter,
        onClickCategory,
        onClickDocument,
        onClickSearchResult,
        onLoadMoreSeminars,
        paging,
    };
};
export default useClientSeminarListSearch;
